import { render, staticRenderFns } from "./OtherInjuredsStep.vue?vue&type=template&id=2d84632b&"
import script from "./OtherInjuredsStep.vue?vue&type=script&lang=js&"
export * from "./OtherInjuredsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports